/**
 * @generated SignedSource<<78c27fe471f1d1b90eb02d821680245c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChooseProgramEnrollDialog_enrollments$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly program: {
        readonly id: string;
      };
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ChooseProgramEnrollDialog_enrollments";
};
export type ChooseProgramEnrollDialog_enrollments$key = {
  readonly " $data"?: ChooseProgramEnrollDialog_enrollments$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChooseProgramEnrollDialog_enrollments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChooseProgramEnrollDialog_enrollments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EnrollmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Enrollment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Program",
              "kind": "LinkedField",
              "name": "program",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EnrollmentConnection",
  "abstractKey": null
};

(node as any).hash = "737cb3e87986f5482aec555ba29cb206";

export default node;
